import script from "./AiCoverLetterConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCoverLetterConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./AiCoverLetterConfirmModal.vue?vue&type=style&index=0&id=1e639b78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e639b78"]])

export default __exports__